import { useMemo } from "react";

import Loading from "react-loading";
import { useSelector } from "react-redux";

import { isMConfProvider } from "utils/providerUtils";

import { menu } from "./constants";
import { IMenuTab } from "./interface";
import { Container, ContainerLoading } from "./styles";
import MenuTabsKenta from "../../../components/MenuTabsKenta";

const RightTemplate: React.FC<
  IMenuTab & { videoRef: React.RefObject<HTMLVideoElement>; hearing?: any }
> = ({
  defaultPage = 0,
  transcription,
  summary,
  ata,
  mark,
  setPage,
  loadingAba,
  videoRef,
  hearing,
}) => {
  const { configurations } = useSelector((store: any) => store);

  const isSynchronizedTextEnabled = useMemo(() => {
    return (
      configurations?.globalConfigurations?.find(
        (config: any) => config.name === "TranscriptionProvider",
      )?.value === "4"
    );
  }, [configurations]);

  const videoRecorderProvider = useMemo(() => {
    return configurations?.globalConfigurations?.find(
      (config: any) => config.name === "RecordProvider",
    )?.value;
  }, [configurations]);

  const isMconf = isMConfProvider(hearing?.recordMode, videoRecorderProvider);

  const menuData = menu({
    transcription,
    summary,
    mark,
    ata,
    videoRef,
    isAISummaryEnabled: !isMconf,
    isSynchronizedTextEnabled: isSynchronizedTextEnabled && !isMconf,
    disabledButton: isSynchronizedTextEnabled,
    shouldHideTranscriptionTab: isMconf,
  });

  const tabIndex = menuData.menusList.findIndex(
    (menu) => menu.pageValue === defaultPage,
  );

  const onSetPage = (page: number) => {
    const menu = menuData.menusList.find((menu) => menu.id === page);
    setPage(menu?.pageValue || 0);
  };

  return (
    <Container>
      {loadingAba && (
        <ContainerLoading>
          <Loading width={40} type="spin" color="#000" />
        </ContainerLoading>
      )}
      <MenuTabsKenta
        bodyList={menuData.bodyList}
        menuList={menuData.menusList}
        pageDefault={tabIndex || 0}
        setPage={onSetPage}
      />
    </Container>
  );
};

export default RightTemplate;
